import {
  type DashRouteType,
  URL_APP_ADMIN,
  URL_PARTNER_SCOPED,
} from '@retailer-platform/dashboard/routing'

/*
 * Partner scoped routes
 */
const URL_PARTNER_MARKETING_TOOLING_CAMPAIGNS = `${URL_PARTNER_SCOPED}/marketing-tooling/campaigns`
const URL_PARTNER_MARKETING_TOOLING_CAMPAIGNS_CREATE = `${URL_PARTNER_SCOPED}/marketing-tooling/campaigns/create`
const URL_PARTNER_MARKETING_TOOLING_CAMPAIGNS_EDIT = `${URL_PARTNER_SCOPED}/marketing-tooling/campaigns/:campaignId/edit`
const URL_PARTNER_MARKETING_TOOLING_CAMPAIGNS_VIEW = `${URL_PARTNER_SCOPED}/marketing-tooling/campaigns/:campaignId`

/*
 * Admin routes
 */
const URL_ADMIN_MARKETING_TOOLING_CAMPAIGNS = `${URL_APP_ADMIN}/marketing-tooling/campaigns`
const URL_ADMIN_MARKETING_TOOLING_CAMPAIGNS_CREATE = `${URL_APP_ADMIN}/marketing-tooling/campaigns/create`
const URL_ADMIN_MARKETING_TOOLING_CAMPAIGNS_EDIT = `${URL_APP_ADMIN}/marketing-tooling/campaigns/:campaignId/edit`
const URL_ADMIN_MARKETING_TOOLING_CAMPAIGNS_VIEW = `${URL_APP_ADMIN}/marketing-tooling/campaigns/:campaignId`
// @hygen:inject scoped-urls

export type DashRouteSet =
  // Partner scoped routes
  | DashRouteType<'app-marketing-tooling-campaigns'>
  | DashRouteType<'app-marketing-tooling-campaigns-create'>
  | DashRouteType<'app-marketing-tooling-campaigns-edit', { campaignId: string }>
  | DashRouteType<'app-marketing-tooling-campaigns-view', { campaignId: string }>

  // Admin routes
  | DashRouteType<'app-admin-marketing-tooling-campaigns'>
  | DashRouteType<'app-admin-marketing-tooling-campaigns-create'>
  | DashRouteType<'app-admin-marketing-tooling-campaigns-edit', { campaignId: string }>
  | DashRouteType<'app-admin-marketing-tooling-campaigns-view', { campaignId: string }>
// @hygen:inject dash-route-set

export const routes: { [Key in DashRouteSet['identifier']]: string } = {
  // Partner scoped routes
  'app-marketing-tooling-campaigns': URL_PARTNER_MARKETING_TOOLING_CAMPAIGNS,
  'app-marketing-tooling-campaigns-create': URL_PARTNER_MARKETING_TOOLING_CAMPAIGNS_CREATE,
  'app-marketing-tooling-campaigns-edit': URL_PARTNER_MARKETING_TOOLING_CAMPAIGNS_EDIT,
  'app-marketing-tooling-campaigns-view': URL_PARTNER_MARKETING_TOOLING_CAMPAIGNS_VIEW,

  // Admin routes
  'app-admin-marketing-tooling-campaigns': URL_ADMIN_MARKETING_TOOLING_CAMPAIGNS,
  'app-admin-marketing-tooling-campaigns-create': URL_ADMIN_MARKETING_TOOLING_CAMPAIGNS_CREATE,
  'app-admin-marketing-tooling-campaigns-edit': URL_ADMIN_MARKETING_TOOLING_CAMPAIGNS_EDIT,
  'app-admin-marketing-tooling-campaigns-view': URL_ADMIN_MARKETING_TOOLING_CAMPAIGNS_VIEW,
  // @hygen:inject route-pair
}

export type DomainRouteName = keyof typeof routes
